import { createContext, useContext } from "solid-js";
import type { ListGroup, ListWithMeta } from "@listto/shared";

interface AppLayoutContextValue {
  openNewListDialog: (groupId?: string) => void;
  openChoiceDialog: (groupId?: string) => void;
  openEditListDialog: (list: ListWithMeta) => void;
  openShareListDialog: (list: ListWithMeta) => void;
  openEditGroupDialog: (group: ListGroup) => void;
  activeDragId: () => string | null;
}

export const AppLayoutContext = createContext<AppLayoutContextValue>();

export const useAppLayoutContext = () => {
  const context = useContext(AppLayoutContext);
  if (!context) {
    throw new Error("useAppLayoutContext must be used within an AppLayout");
  }
  return context;
};
